import { render, staticRenderFns } from "./businessDetailOrder.vue?vue&type=template&id=be2fc18c&scoped=true"
import script from "./businessDetailOrder.vue?vue&type=script&lang=js"
export * from "./businessDetailOrder.vue?vue&type=script&lang=js"
import style0 from "./businessDetailOrder.vue?vue&type=style&index=0&id=be2fc18c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2fc18c",
  null
  
)

export default component.exports